export enum AccessGroupFilterOptions {
    None = 1,
    DeletedAccessGroups = 2
}